import React from "react";
import {
  Button,
  Col,
  Offcanvas,
  OffcanvasBody,
  OffcanvasHeader,
  Row,
  Table,
} from "reactstrap";
import { imageBaseApi } from "../../../utilis/imageHelper";
import { Download } from "lucide-react";

const FranchisePrivateDetail = ({ isOpen, toggle, selectedItem }) => {
  const renderItem = (label, value) => (
    <div className="mb-3">
      <div className="text-muted small">{label}</div>
      <div className="fw-semibold">
        {value || <span className="text-muted">N/A</span>}
      </div>
    </div>
  );

  return (
    <Offcanvas isOpen={isOpen} toggle={toggle} direction="end">
      <OffcanvasHeader toggle={toggle}>
        Franchise Private Detail
      </OffcanvasHeader>

      <OffcanvasBody>
        <div className="p-2">
          {/* Section: Basic Info */}
          <h6 className="mb-3 text-primary">Basic Information</h6>
          {renderItem(
            "Where are your Preferred Locations to open Kangaroo Education Foundation's Regional Office?",
            selectedItem?.whereAbouts,
          )}
          {renderItem(
            "Why are you interested in opening Kangaroo Education Foundation's Regional Office?",
            selectedItem?.insOpening,
          )}

          <hr />

          {/* Section: Experience */}
          <h6 className="mb-3 text-primary">Experience</h6>
          {renderItem(
            "Do you have any prior experience in Education Consultancy or Education Sector?",
            selectedItem?.priorExp,
          )}
          {renderItem(
            "Do you have any prior experience in Franchise Business?",
            selectedItem?.frnExp,
          )}

          <hr />

          {/* Section: Preferences */}
          <h6 className="mb-3 text-primary">Preferences</h6>
          {renderItem(
            "Are you planning to operate this business as your full-time endeavor?",
            selectedItem?.plan,
          )}
          {renderItem(
            "Are you a local resident where you want to open Kangaroo Education Foundation's?",
            selectedItem?.localResident,
          )}
          {renderItem(
            "Are you the sole Investor if you obtain the Kangaroo Education Foundation's Regional Office, or are there other investors involved?",
            selectedItem?.investor,
          )}

          <hr />

          {/* Section: Attachment */}
          <h6 className="mb-3 text-primary">Attachment</h6>
          {selectedItem?.attachmentUrl ? (
            <Button
              color="primary"
              tag="a"
              href={`${imageBaseApi}${selectedItem?.attachmentUrl}`}
              target="_blank"
              rel="noopener noreferrer"
              className="d-inline-flex align-items-center"
            >
              <Download size={16} className="me-2" />
              Download EOI
            </Button>
          ) : (
            <div className="text-muted">No EOI uploaded</div>
          )}
        </div>
      </OffcanvasBody>
    </Offcanvas>
  );
};
export default FranchisePrivateDetail;
